export default __webpack_public_path__ + "static/logo-green-c5d5da10b49a6424f9fca04a241f4d20.svg";